import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    expanded: { type: Boolean, default: true }
  }

  static targets = ["content", "toggleIcon", "title"]

  static classes = ["expanded", "collapsed", "hiddenContent", "rotateIcon", "hiddenTitle"]

  // ---------------------------------------------------------------------------
  // Actions
  // ---------------------------------------------------------------------------

  toggle() {
    this.expandedValue = !this.expandedValue;
  }

  open() {
    this.expandedValue = true;
  }

  close() {
    this.expandedValue = false;
  }

  // ---------------------------------------------------------------------------
  // Value callbacks
  // ---------------------------------------------------------------------------

  expandedValueChanged(value) {
    // (a) Swap width classes on root element
    if (value) {
      this.element.classList.add(...this.expandedClasses);
      this.element.classList.remove(...this.collapsedClasses);
    } else {
      this.element.classList.remove(...this.expandedClasses);
      this.element.classList.add(...this.collapsedClasses);
    }

    // (b) Show/hide content area
    if (this.hasContentTarget) {
      if (value) {
        this.contentTarget.classList.remove(...this.hiddenContentClasses);
      } else {
        this.contentTarget.classList.add(...this.hiddenContentClasses);
      }
    }

    // (c) Update toggle button aria-expanded and icon rotation
    if (this.hasToggleIconTarget) {
      const button = this.toggleIconTarget.closest("button") || this.toggleIconTarget;
      button.setAttribute("aria-expanded", value.toString());
      // Rotate 180° when collapsed so the chevron points "open" direction
      if (value) {
        this.toggleIconTarget.classList.remove(...this.rotateIconClasses);
      } else {
        this.toggleIconTarget.classList.add(...this.rotateIconClasses);
      }
    }

    // (d) Show/hide title text when collapsing
    if (this.hasTitleTarget) {
      if (value) {
        this.titleTarget.classList.remove(...this.hiddenTitleClasses);
      } else {
        this.titleTarget.classList.add(...this.hiddenTitleClasses);
      }
    }
  }
}
